var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionNewM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 861,
    viewBox: "0 0 750 861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3015_7873",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 752,
    height: 862,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    width: 752,
    height: 862
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245 41H375H505C461.72 41 441.902 28.6852 424.258 17.7216C410.103 8.92597 397.347 1 375 1C352.648 1 339.892 8.92667 325.737 17.7228C308.095 28.6861 288.278 41 245 41ZM750 41V861H0V41H750Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245 41H375H505C461.72 41 441.902 28.6852 424.258 17.7216C410.103 8.92597 397.347 1 375 1C352.648 1 339.892 8.92667 325.737 17.7228C308.095 28.6861 288.278 41 245 41ZM750 41V861H0V41H750Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.258 17.7216L423.73 18.571L424.258 17.7216ZM325.737 17.7228L326.265 18.5721L325.737 17.7228ZM750 861V862H751V861H750ZM750 41H751V40H750V41ZM0 861H-1V862H0V861ZM0 41V40H-1V41H0ZM375 40H245V42H375V40ZM505 40H375V42H505V40ZM423.73 18.571C432.551 24.0521 441.998 29.9257 454.682 34.4148C467.371 38.9064 483.26 42 505 42V40C483.459 40 467.799 36.9362 455.349 32.5295C442.892 28.1203 433.608 22.3546 424.785 16.8722L423.73 18.571ZM375 2C397.046 2 409.595 9.78761 423.73 18.571L424.785 16.8722C410.611 8.06432 397.648 0 375 0V2ZM326.265 18.5721C340.4 9.78833 352.949 2 375 2V0C352.347 0 339.384 8.06502 325.209 16.8734L326.265 18.5721ZM245 42C266.739 42 282.627 38.9066 295.316 34.4153C307.998 29.9264 317.445 24.0531 326.265 18.5721L325.209 16.8734C316.387 22.3557 307.104 28.1211 294.648 32.5299C282.199 36.9364 266.54 40 245 40V42ZM751 861V41H749V861H751ZM0 862H750V860H0V862ZM-1 41V861H1V41H-1ZM750 40H0V42H750V40Z",
    fill: "#EAE4E3",
    mask: "url(#path-1-outside-1_3015_7873)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionNewM);
export default __webpack_public_path__ + "static/media/unionNewM.88cd13854e907fa65f2484d910d74dac.svg";
export { ForwardRef as ReactComponent };